import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Buffer } from "buffer";
import i18n from "./i18n";
import "./App.css";
import ElevvaLoader from "./components/ui/ElevvaLoader/ElevvaLoader";
import AppRoutes from "./routes/AppRoutes";

global.Buffer = Buffer;

function App() {
  const { t } = useTranslation();
  useEffect(() => { i18n.changeLanguage("es"); }, []);
  return (
    <div className="col-12 d-md-flex" style={{ height: "100vh", backgroundColor: "#FFFFFF" }}>
      <div className="flex-grow-1 w-100 d-flex flex-column">
        <React.Suspense fallback={<ElevvaLoader variant="page" label="Cargando Elevva…" />}>
          <AppRoutes elevvaT={t} />
        </React.Suspense>
      </div>
    </div>
  );
}
export default App;
